import { bd, } from '@tymia/shared';
const DECIMAL_RE = /^-?(?:0|[1-9]\d*)(?:\.\d+)?$/;
const decimal = {
    type: 'string',
    validate: (value) => {
        if (!DECIMAL_RE.test(value)) {
            return false;
        }
        return bd(value).isFinite();
    },
    compare: (a, b) => {
        return bd(a).cmp(bd(b));
    },
};
export const formats = {
    decimal,
};
//# sourceMappingURL=customFormats.js.map